import type { SelectTypeOption } from './types';

type Type =  'industries' | 'services' | 'categories' | 'impacts';
interface Option {
    referenceId: string;
    value: string;
}

function filter(input: Option[], predicate: (option: Option) => boolean): SelectTypeOption[] {
    return input.reduce((acc: SelectTypeOption[], option: Option) => {
        if (predicate(option)) {
            return acc.concat([{
                label: option.value,
                value: option.referenceId
            }]);
        } else {
            return acc;
        }
    }, []);
}

export const reducerWithSubset = (input: Option[], subset: string[]): SelectTypeOption[] => {
    return filter(input, option => subset.includes(option.referenceId));
};

export const reducerWithBlackList = (input: Option[], type: Type): SelectTypeOption[] => {
    const excluded: string[] = blacklist[type] || [];
    return filter(input, option => !excluded.includes(option.referenceId));
};

const blacklist: Record<Type, string[]> = {
    industries: [
        // 'mk_industries_automotive_manufacturing', // Automotive & Manufacturing
        // 'mk_industries_energy_utilities', // Energy & Utilities
        // 'mk_industries_financial_services', // Financial Services
        // 'mk_industries_healthcare', // Healthcare
        // 'mk_industries_logistics', // Logistics
        // 'mk_industries_retail_consumer_products', // Retail & Consumer Products
        // 'mk_industries_telco_media', // Telco & Media
        'mk_industries_technology'
    ],
    services: [
        // 'mk_digital_assets', // Digital Assets
        // 'mk_services_artificial_intelligence', // Artificial Intelligence
        // 'mk_services_cloud_computing', // Cloud Computing
        // 'mk_services_communication_networks', // Telco Networks
        // 'mk_services_cx_digital_commerce', // CX & Digital Commerce
        // 'mk_services_cybersecurity', // Cybersecurity
        // 'mk_services_data_world', // Data World
        // 'mk_services_design', // Design
        // 'mk_services_digital_experience', // Digital Experience
        // 'mk_services_gaming', // Gaming
        // 'mk_services_hybrid_work', // Hybrid Work
        // 'mk_services_immersive_experience', // 3D & Mixed Reality
        // 'mk_services_iot', // Internet of Things
        // 'mk_services_low_code', // Low Code
        // 'mk_services_metaverse', // Metaverse
        // 'mk_services_quality_engineering', // Quality Engineering
        // 'mk_services_quantum_computing', // Quantum Computing
        // 'mk_services_risk_management', // Governance, Risk & Compliance
        // 'mk_services_robotics_autonomous_things', // Robotics & Autonomous Things
        // 'mk_services_social_media', // Social Media
        // 'mk_services_strategy_advisory', // Strategy & Business Model Transformation
        // 'mk_services_supply_chain_management', // Supply Chain Management
    ],
    categories: [
        'big-story',
        'product-website',
        'offering',
        'rose'
    ],
    impacts: []
};